<template>
  <div class="login-container">
    <div class="title-container">
      <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/login/logo.png"  alt="">
      <h3 class="title">智鼎云商办智能管理平台</h3>
    </div>
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
      <div class="form-container">
        <h4 class="title-tips">
          欢迎登陆
        </h4>
        <el-form-item prop="username">
          <span class="svg-container">
            手机号  
          </span>
          <el-input ref="username"
            v-model="loginForm.username"
            placeholder="请输入手机号"
            name="username"
            type="text"
            tabindex="1"
            auto-complete="on"></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <span class="svg-container">
            登录密码
          </span>
          <el-input
            :key="passwordType"
            ref="password"
            
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="请输入密码"
            name="password"
            tabindex="2"
            auto-complete="on"
            @keyup.enter.native="handleLogin"
          />

        </el-form-item>

        <el-button :loading="loading" type="primary" round class="form-btn" @click.native.prevent="handleLogin">登录</el-button>

        <div class="agreement" @click="$router.push('/agreement')">《智鼎云隐私协议》</div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { validUsername } from '@/utils/validate'

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      console.log(value)
      if (!validUsername(value)) {
        callback(new Error('请输入正确的用户名'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能少于6位'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    reverse( str ){
      return str.split('').reverse().join('');
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {       
        if (valid) {
          this.$router.push('/')
          // let loginForm=Object.assign({},this.loginForm);
          // loginForm.password=this.loginForm.password
          // // loginForm.password=md5(md5(this.reverse(this.loginForm.password+'Qx1024')))
          // this.loading = true
          // this.$store.dispatch('user/login', loginForm).then(() => {
          //   this.$router.push({ path: this.redirect || '/' })
          //   this.loading = false
          // }).catch(() => {
          //   this.loading = false
          // })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

.login-container {
  .el-input__inner{
    border-color:#A3A3A3!important;
  }
  .el-input {
    display: inline-block;
    height: 47px;
    width: 77%;
    input {
      background: white;
      border: 1px solid #A3A3A3;
      -webkit-appearance: none;
      border-radius: 4px;
      height: 47px;
      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #283443 inset !important;
        -webkit-text-fill-color: #fff !important;
      }
    }
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: white;
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="less" scoped>

.login-container {
  min-height: 100vh;
  width: 100%;
  
  background: url("https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/login/denlubj.png") no-repeat center center;
  background-size: cover;
  overflow: hidden;
  .login-form {
    position: relative;
    width:600px;
    max-width: 100%;
    // padding: 100px 0 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 0 10px 0 0;
    color:#333333;
    vertical-align: middle;
    width: 66px;
    font-size:16px;
    text-align: right;
    display: inline-block;
  }

  .title-container {
    position: relative;
    text-align: center;
    margin-top:64px;
    margin-bottom:100px;
    img{
      width:344px;
    }
    .title {
      width:100%;
      font-size: 26px;
      color:#231815;
      text-align:center;
      font-weight: bold;
    }
  }
  .form-container{
    background: white;
    padding:69px 98px 98px;
    border-radius:6px;
    .title-tips{
      font-size:26px;
      font-weight:bold;
      color:rgba(38,38,38,1);
      text-align: center;
      margin-bottom:60px;
    }
    .form-btn{
      width:404px;
      margin:30px 0;
      background: #FF7A32;
      border:none;
    }
    .form-btn:active{
      background: #FF9A78;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color:#fff;
    cursor: pointer;
    user-select: none;
  }
  .agreement{
    text-align: center;
    color: #FF7A32;
  }
  .agreement:hover{
    
    cursor: pointer;
  }
}
</style>
